import { render } from "./RatingPersona.vue?vue&type=template&id=5bf0f36c&scoped=true"
import script from "./RatingPersona.vue?vue&type=script&lang=js"
export * from "./RatingPersona.vue?vue&type=script&lang=js"

import "./RatingPersona.vue?vue&type=style&index=0&id=5bf0f36c&lang=css"
import "./RatingPersona.vue?vue&type=style&index=1&id=5bf0f36c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf0f36c"]])

export default __exports__